import firebase from "../../config/firebase";
export const addContract =
  (data, onComplete = () => {}) =>
  () => {
    firebase
      .firestore()
      .collection("users")
      .doc(data.id)
      .update({
        name: data.name,
        contract: true,
      })
      .then(() => {
        onComplete();
      });
  };

export const submitContractRequest =
  (data, onComplete = () => {}) =>
  async (dispatch) => {
    let { imageURL, ...prevData } = data;
    const storageRef = firebase.storage().ref();
    const imageRef = storageRef.child(`images/${imageURL.name}`);
    await imageRef.put(imageURL);
    const imageUrl = await imageRef.getDownloadURL();
    const querySnapshot = await firebase
      .firestore()
      .collection("schoolContracts")
      .orderBy("cid", "desc")
      .limit(1)
      .get();

    let cid = 101;
    if (!querySnapshot.empty) {
      const lastContract = querySnapshot.docs[0].data();
      cid = lastContract.cid + 1;
    }
    let newData = {
      ...prevData,
      cid: cid,
      imageURL: imageUrl,
    };
    const docRef = await firebase
      .firestore()
      .collection("schoolContracts")
      .add(newData);
    const notificationData = {
      createdAt: firebase.firestore.FieldValue.serverTimestamp(),
      type: "IP Contract",
      notifyID: docRef.id,
      image: imageUrl,
      status: false,
    };
    console.log(
      notificationData,
      "submit contract request notificationData>>>>>>>>>>>>>>"
    );
    await firebase
      .firestore()
      .collection("admin_notifiaction")
      .add(notificationData);
    onComplete();
  };
